module.exports = __webpack_public_path__ + "img/ico-profile.9f4a8c9a.svg";